/** Zip. */
export class Zip {
  constructor(data) {
    this.areaCode = data.areaCode;
    this.city = data.city;
    this.county = data.county;
    this.countyFip = data.countyFip;
    this.daylightSavings = data.daylightSavings;
    this.elevation = data.elevation;
    this.id = data.id;
    this.latitude = data.latitude;
    this.longitude = data.longitude;
    this.state = data.state;
    this.stateCode = data.stateCode;
    this.timezone = data.timezone;
    this.zip = data.zip;
  }
}
